import { PayloadAction, createSlice, current } from "@reduxjs/toolkit";
import { SubAccountActions } from "./subaccount.actions";
import { DefinedCustomDates } from "../../../Models/defaultSelectOptions";
//import { DefinedCustomDates } from "../../../Models/defaultSelectOptions";

interface initialStateTypes {
  subAccountListing: any;
  singleAccountDetails: any;
  subAccountCreditLogs: any;
  selfCreditLogs: any;
  creditsModified: any;
  subAccountPricingData: any;
  domainDetailsData:any
  subAccountRenewSubscription:any,
  subAccountUserPlans:any,
  subAccountDisableUser:any,
  subAccountUpgradePlan:any,
  subAccountUserPassword:any;
  
}

const initialState: initialStateTypes = {
  subAccountListing: [],
  singleAccountDetails: [],
  subAccountCreditLogs: [],
  selfCreditLogs: [],
  creditsModified: null,
  subAccountPricingData: null,
  domainDetailsData:null,
  subAccountRenewSubscription:null,
  subAccountUserPlans:[],
  subAccountDisableUser:null,
  subAccountUpgradePlan:[],
  subAccountUserPassword:null,
};
const updateAccountCredits = (state: initialStateTypes, action: any) => {
  // You can directly read and update state here
  let listingArray = current(state).subAccountListing.data.map((ele: any) => {
    // Create a shallow copy of the element to avoid modifying the original
    const updatedEle = { ...ele };
    if (updatedEle.workspace_id === action.workspace_id) {
      updatedEle.credits = action.credits; // Modify the copied object
    }
    return updatedEle; // Return the modified (or original) element
  });
  state.subAccountListing.data = [...listingArray];
  state.singleAccountDetails = [];
};
const SubaccountSlice = createSlice({
  name: "DashboardSlice",
  initialState,
  reducers: {
    resetPrice(state, { payload }: PayloadAction<any>) {
      const newUserInput = payload;
      state.subAccountPricingData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        SubAccountActions.getSubAccountsListing.pending,
        (state, action) => {
          state.subAccountListing = [];
        },
      )
      .addCase(
        SubAccountActions.getSubAccountsListing.fulfilled,
        (state, action) => {
          state.subAccountListing = action.payload?.data;
        },
      )
      .addCase(
        SubAccountActions.getSubAccountsListing.rejected,
        (state, action) => {
          state.subAccountListing = [];
        },
      )
      .addCase(
        SubAccountActions.getSubAccountsCredit.pending,
        (state, action) => {
          state.singleAccountDetails = [];
        },
      )
      .addCase(
        SubAccountActions.getSubAccountsCredit.fulfilled,
        (state, action) => {
          updateAccountCredits(state, action.payload?.data.data[0]);
        },
      )
      .addCase(
        SubAccountActions.getSubAccountsCredit.rejected,
        (state, action) => {
          state.singleAccountDetails = {};
        },
      )
      .addCase(
        SubAccountActions.getSubAccountsCreditsLogs.pending,
        (state, action) => {
          state.subAccountCreditLogs = [];
        },
      )
      .addCase(
        SubAccountActions.getSubAccountsCreditsLogs.fulfilled,
        (state, action) => {
          state.subAccountCreditLogs = action.payload?.data;
        },
      )
      .addCase(
        SubAccountActions.getSubAccountsCreditsLogs.rejected,
        (state, action) => {
          state.subAccountCreditLogs = {};
        },
      )
      .addCase(
        SubAccountActions.getSlefCreditsLogs.pending,
        (state, action) => {
          state.selfCreditLogs = [];
        },
      )
      .addCase(
        SubAccountActions.getSlefCreditsLogs.fulfilled,
        (state, action) => {
          state.selfCreditLogs = action.payload?.data;
        },
      )
      .addCase(
        SubAccountActions.getSlefCreditsLogs.rejected,
        (state, action) => {
          state.selfCreditLogs = {};
        },
      )
      .addCase(SubAccountActions.manageCredits.pending, (state, action) => {
        state.creditsModified = null;
      })
      .addCase(SubAccountActions.manageCredits.fulfilled, (state, action) => {
        state.creditsModified = action.payload?.data;
      })
      .addCase(SubAccountActions.manageCredits.rejected, (state, action) => {
        state.creditsModified = null;
      })
      .addCase(SubAccountActions.getSubAccountPricing.pending, (state, action) => {
        state.subAccountPricingData = null;
      })
      .addCase(SubAccountActions.getSubAccountPricing.fulfilled, (state, action) => {
        state.subAccountPricingData = action.payload?.data.data;
      })
      .addCase(SubAccountActions.getSubAccountPricing.rejected, (state, action) => {
        state.subAccountPricingData = null;
      })
      .addCase(SubAccountActions.setSubAccountPricing.pending, (state, action) => {
        state.subAccountPricingData = null;
      })
      .addCase(SubAccountActions.setSubAccountPricing.fulfilled, (state, action) => {
        state.subAccountPricingData = action.payload?.data.data;
      })
      .addCase(SubAccountActions.setSubAccountPricing.rejected, (state, action) => {
        state.subAccountPricingData = null;
      })
      .addCase(SubAccountActions.getDomainDetails.pending, (state, action) => {
        state.domainDetailsData = null;
      })
      .addCase(SubAccountActions.getDomainDetails.fulfilled, (state, action) => {
        state.domainDetailsData = action.payload?.data.data;
      })
      .addCase(SubAccountActions.getDomainDetails.rejected, (state, action) => {
        state.domainDetailsData = null;
      }).
      // addCase(SubAccountActions.setRenewSubscription.pending, (state, action) => {  // for Renewing Plan
      //   state.subAccountRenewSubscription = null;
      // })
      // .addCase(SubAccountActions.setRenewSubscription.fulfilled, (state, action) => {
      //   state.subAccountRenewSubscription = action.payload?.data;
      // })
      // .addCase(SubAccountActions.setRenewSubscription.rejected, (state, action) => {
      //   state.subAccountRenewSubscription = null;
      // }).
      addCase(SubAccountActions.getPlansForMaster.pending, (state, action) => { // for getting plans
        state.subAccountUserPlans = null;
      })
      .addCase(SubAccountActions.getPlansForMaster.fulfilled, (state, action) => {
        state.subAccountUserPlans = action.payload?.data;
      })
      .addCase(SubAccountActions.getPlansForMaster.rejected, (state, action) => {
        state.subAccountUserPlans = null;
      }).
      addCase(SubAccountActions.setDisableUser.pending, (state, action) => {  // for disabling Users
        state.subAccountDisableUser = null;
      })
      .addCase(SubAccountActions.setDisableUser.fulfilled, (state, action) => {
        state.subAccountDisableUser = action.payload?.data;
      })
      .addCase(SubAccountActions.setDisableUser.rejected, (state, action) => {
        state.subAccountDisableUser = null;
      }).addCase(SubAccountActions.setUpgradePlan.pending, (state, action) => {  // for Upgrading Plan
        state.subAccountUpgradePlan = null;
      })
      .addCase(SubAccountActions.setUpgradePlan.fulfilled, (state, action) => {
        state.subAccountUpgradePlan = action.payload?.data;
      })
      .addCase(SubAccountActions.setUpgradePlan.rejected, (state, action) => {
        state.subAccountUpgradePlan = null;
      }).addCase(SubAccountActions.setResetPassword.pending, (state, action) => {
        state.subAccountUserPassword = null;
      })
      .addCase(SubAccountActions.setResetPassword.fulfilled, (state, action) => {
        state.subAccountUserPassword = action.payload?.data;
      })
      .addCase(SubAccountActions.setResetPassword.rejected, (state, action) => {
        state.subAccountUserPassword = null;
      });

  },
});
export const {resetPrice} = SubaccountSlice.actions;
export default SubaccountSlice.reducer;
